const UNKNOWN_ICON_CODE = '44';

// See https://www.figma.com/file/MIHrw2CP5lT6d1iVYOm8pM/Icons-%26-Illustrations?node-id=5883%3A2305
const weatherIconCodes: Record<WeatherIconCode, WeatherIconName> = {
    '00': 'tornado',
    '01': 'tropical_storm',
    '02': 'tropical_storm',
    '03': 'thunderstorms',
    '04': 'thunderstorms',
    '05': 'winter_mix',
    '06': 'rain_sleet',
    '07': 'winter_mix',
    '08': 'rain_sleet',
    '09': 'drizzle',
    '10': 'rain_sleet',
    '11': 'rain',
    '12': 'rain',
    '13': 'flurries',
    '14': 'snow',
    '15': 'snow_drift',
    '16': 'snow',
    '17': 'hail',
    '18': 'hail',
    '19': 'smoke_dust',
    '20': 'fog_haze',
    '21': 'fog_haze',
    '22': 'smoke_dust',
    '23': 'wind',
    '24': 'wind',
    '25': 'cold',
    '26': 'cloudy',
    '27': 'mostly_cloudy_night',
    '28': 'mostly_cloudy',
    '29': 'partly_cloudy_night',
    '30': 'partly_cloudy',
    '31': 'clear_night',
    '32': 'sunny',
    '33': 'mostly_clear_night',
    '34': 'mostly_sunny',
    '35': 'rain_sleet',
    '36': 'hot',
    '37': 'isolated_thunderstorms',
    '38': 'scattered_thunderstorms',
    '39': 'scattered_showers',
    '40': 'heavy_rain',
    '41': 'scattered_snow_showers',
    '42': 'heavy_snow',
    '43': 'heavy_snow',
    [UNKNOWN_ICON_CODE]: 'not_available',
    '45': 'scattered_showers_night',
    '46': 'scattered_snow_showers_night',
    '47': 'scattered_thunderstorms_night',
};

export function getWeatherIconCode(code: WeatherIconCode) {
    if (weatherIconCodes[code]) return code;
    return UNKNOWN_ICON_CODE;
}

export {default as WeatherErrorIcon24px} from './alert-cloud-24px.svg?react';
export {default as WeatherErrorIcon48px} from './alert-cloud-48px.svg?react';
